module.exports = __webpack_public_path__ + "img/undraw_Upvote_re_qn2k.d106ef36.svg";